/**
 * @desc undefined
 */
import { AbortiveExplainEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAbortiveExplainParameter = {
  auctionId?: string
}

const method = 'GET'
const url = '/trade/abortiveExplain/getByAuctionId'

export const queryAbortiveExplainApi = (
  params?: QueryAbortiveExplainParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AbortiveExplainEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAbortiveExplainApi.method = method
queryAbortiveExplainApi.url = url
